import { tv } from '@/common/theme/tv.config';

export const styles = {
  root: tv({
    base: 'w-full',
    variants: {
      type: {
        success: 'bg-systemSuccess10',
        warning: 'bg-systemWarning10',
        error: 'bg-systemError10',
        info: 'bg-systemInfo10',
      },
      noBackground: {
        true: 'gap-sm rounded-[0] bg-[transparent] p-0',
        false: 'gap-sm rounded-lg p-sm md:gap-md md:rounded-xl md:p-md',
      },
    },
  }),
  icon: tv({
    base: 'h-lg w-lg flex-shrink-0 rounded-full p-[0.5rem] text-neutral30',
    variants: {
      type: {
        success: 'bg-systemSuccess20',
        warning: 'bg-systemWarning20',
        error: 'bg-systemError20',
        info: 'bg-systemInfo20',
      },
      noBackground: {
        true: 'h-[2rem] w-[2rem] bg-[transparent] p-0',
        false: '',
      },
    },
  }),
  contentContainer: 'flex-1',
  content: tv({
    base: 'flex-1',
    variants: {
      type: {
        success: '',
        warning: '',
        error: '',
        info: '',
      },
      noBackground: {
        true: 'text-sm/[1.5]',
        false: 'text-sm/[1.5] md:text-md/[1.5]',
      },
    },
    compoundVariants: [
      {
        noBackground: true,
        type: 'success',
        className: 'text-systemSuccess',
      },
      {
        noBackground: true,
        type: 'warning',
        className: 'text-systemWarning',
      },
      {
        noBackground: true,
        type: 'error',
        className: 'text-systemError',
      },
      {
        noBackground: true,
        type: 'info',
        className: 'text-systemInfo',
      },
    ],
  }),
  contentCloseButton: 'pt-xs pb-0 px-[0.8rem]',
};
